
import { defineComponent, PropType } from 'vue';

import type { ExtrasProductDropDownItem } from '@white-label-types/search-box';

import { DropdownWrapper } from 'ui-shared-components';
import type { DropdownItems, DropdownSingleItem } from '@white-label-types/dropdown';
import { APP_HERO_PRODUCT_NAMES, APP_HERO_PRODUCTS } from '@white-label-configuration/constants';

export default defineComponent({
  name: 'SearchBoxExtrasProductInput',
  components: {
    DropdownWrapper,
    IconGlass: () => import('@white-label-icon/icon-glass'),
    IconFastforward: () => import('@white-label-icon/icon-fastforward'),
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    extraProducts: {
      type: Array as PropType<string[]>,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dropdownOpen: false,
    };
  },

  computed: {
    items(): DropdownItems {
      return this.extraProducts
        .map((item: string): DropdownSingleItem => {
          return ({
            name: APP_HERO_PRODUCT_NAMES[item.toUpperCase()],
            id: item.toLowerCase()
          })
        });
    },
    selectedExtraProductItem(): DropdownSingleItem {
      if (this.value === '') {
        return this.items[0];
      }
      const selectedItem = this.items
          .find((item: DropdownSingleItem) => item.id === this.value.toLowerCase());

      if (!selectedItem) {
        return { name: '', id: '', };
      }

      return selectedItem;
    },
    isFasttrackSelected(): boolean {
      return this.value === APP_HERO_PRODUCTS.FASTTRACK;
    },
  },
  methods: {
    onSelectExtraProduct(value: ExtrasProductDropDownItem): void {
      this.dropdownOpen = false;
      this.$emit('input', value.id);
    },
  },
});
